<div class="custom-popup-gen-container link-account-dialog">

    <div class="custom-popup-gen-header">
        <div class="title">
            <h3 id="title-text">{{getWarningMessageFromSitecore('b2b.register.registerlinkaccount')?.title || 'Link Account'}}</h3>
            <p class="subtitle">
                {{ manageTrvlContent?.['b2b.managetraveler.multipleprofilesfound']?.split('{name}')[0] }}
                <strong>{{ fullName | titlecase }}</strong>
                {{ manageTrvlContent?.['b2b.managetraveler.multipleprofilesfound']?.split('{name}')[1] }}
            </p>
        </div>

        <div class="close">
            <button mat-icon-button (click)="onClose()">
                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
            </button>
        </div>
    </div>

    <div class="custom-popup-gen-body">
        <!-- Scrollable Account List -->
        <div class="account-list-wrapper">

            <mat-radio-group class="account-list" aria-label="Select account"
                (change)="selectedContactId = $event.value" [(ngModel)]="selectedContactId">
                <mat-radio-button class="account-card" *ngFor="let profile of idMatchedProfiles"
                    [value]="profile.contactId" (click)="selectedProfile(profile)">

                    <div class="account-details">
                        <!-- Full Name -->
                        <h3>
                            {{ maskName(profile.firstName + profile.lastName) }}
                        </h3>

                        <!-- Email (show first verified OR first email) -->
                        <div class="info-row" *ngIf="getPreferredEmail(profile)">
                            <span>{{ maskEmail(getPreferredEmail(profile)) }}</span>
                        </div>

                        <!-- Mobile -->
                        <div class="info-row" *ngIf="getPreferredMobile(profile)">
                            <span>Contact number</span>
                            <span>{{ maskNumber(getPreferredMobile(profile)) }}</span>
                        </div>

                        <!-- AlFursan ID -->
                        <div class="info-row" *ngIf="profile.fursanId">
                            <span>{{manageTrvlContent?.['b2b.managetraveler.alfursannumber'] || 'AlFursan Id'}}</span>
                            <span>{{ maskNumber(profile.fursanId) }}</span>
                        </div>

                        <!-- National / Passport ID -->
                        <div class="info-row" *ngIf="profile.id?.length">
                            <span>{{ getMatchedIdObj(profile)?.idType | titlecase }}</span>
                            <span>{{ maskNumber(getMatchedIdObj(profile)?.id) }}</span>
                        </div>
                    </div>

                </mat-radio-button>
            </mat-radio-group>


        </div>
    </div>

    <div class="custom-popup-gen-footer">

        <div class="left-content">
            <a target="_blank" (keydown.enter)="notMe()" tabindex="0" role="button" (click)="notMe()"
                [class.disabled]="Loader.isNotMeSpinner">{{ registerDataContent?.warningList?.[4]?.cancelCTAText }}
                <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon></a>
            <div class="spinner">
                <mat-spinner color="primary" *ngIf="Loader.isNotMeSpinner"></mat-spinner>
            </div>
            <!-- <mat-spinner color="primary" diameter="20" class="button"></mat-spinner> -->
        </div>
        <div class="btn-group">
            <!-- <button class="button--secondary-small" mat-button> None is me </button> -->
            <button class="button--primary-small" [class.disabled]="!!!selectedProfileItem || Loader.isSpinner"
                mat-button (click)="thisIsMe()">{{ registerDataContent?.warningList?.[4]?.confirmCTAText }}
                <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
            </button>
        </div>
    </div>
</div>



<!-- System Action-Stop onboarding -->
<div class="custom-popup-gen-container d-none">
    <div class="custom-popup-gen-body">
        <div class="existing-account-container">
            <div class="existing-account-illustration-wrapper">
                <img class="existing-account-illustration-img" src="assets/images/illustrations--SomthingWentWrong.svg"
                    alt="Manage Bookings" width="180" height="134">
                <div class="existing-account-description-wrapper">
                    <h3>{{ registerDataContent?.['b2b.register.invitenotsent'] }}</h3>
                    <div class="content text-center">
                        <p>{{ registerDataContent?.['b2b.register.emailexitsdesc'] || 'Another account already exists
                            with this email address,
                            use a different email address to send invite to the employee.' }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="custom-popup-gen-footer">
        <button class="button--primary-small" mat-button>{{
            getMessageFromSitecore('b2b.register.invitenotsent')?.CTAText ||
            'Got It' }}</button>
    </div>
</div>